import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { LeagueMemberService } from 'src/app/simulator-booking/services/league-member.service';
import { LeagueMember } from 'src/app/simulator-booking/models/league-member';

@Component({
    selector: 'edit-league-member-modal',
    templateUrl: './edit-league-member-modal.component.html',
    styleUrl: './edit-league-member-modal.component.scss',
    standalone: false
})
export class EditLeagueMemberModalComponent extends BaseModalComponent implements OnInit {

    public member: LeagueMember;
    public form = new FormGroup({
        id: new FormControl('', {
            validators: Validators.required
        }),
        firstName: new FormControl('', {
            validators: Validators.required
        }),
        lastName: new FormControl('', {
            validators: Validators.required
        }),
        email: new FormControl('', {
            validators: [Validators.email]
        }),
        leagueId: new FormControl('', {
            validators: Validators.required
        }),
        organizationId: new FormControl('', {
            validators: Validators.required
        }),
        lastEditedBy: new FormControl()
    });

    constructor(
        private sessionService: SessionService,
        private leagueMemberService: LeagueMemberService,
        public dialogRef: MatDialogRef<EditLeagueMemberModalComponent>
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.member) {
            this.form.patchValue({
                id: this.member.id,
                firstName: this.member.firstName,
                lastName: this.member.lastName,
                email: this.member.email,
                leagueId: this.member.leagueId,
                organizationId: this.member.organizationId,
                lastEditedBy: this.sessionService.getUserId()
            });
        }
    }

    submit({ value, valid }): void {
        if (valid) {
            this.isLoading = true;
            const data = {
                ...value,
                organizationId: this.member.organizationId,
                lastEditedBy: this.sessionService.getUserId()
            };

            this.leagueMemberService.update(this.member.id, data).subscribe({
                next: (result) => {
                    if (result !== null && result !== undefined) {
                        this.dialogRef.close("save");
                    }
                },
                error: (error) => {
                    console.error('Error updating league member:', error);
                    this.setErrorV2(error, this.form);
                    this.isLoading = false;
                },
                complete: () => this.isLoading = false
            });
        }
    }
}

